import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import cx from 'classnames';
import { sortCollection } from 'shared/helpers/arrays';
import {
  injectTopMakesToOptions,
  skipTopMakes,
} from 'shared/components/SearchPanel/transformOptions';
import Select from 'react-select';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import SelectTranslated from '../SelectTranslated/SelectTranslated';
import ColorsForm from '../ColorsForm/ColorsForm';
import UpdatedSelect from '../../UpdatedSelect/UpdatedSelect';
import GroupForm from '../GroupForm/GroupForm';
import OptionsForm from '../OptionsForm/OptionsForm';
import s from './CarsPanel.css';

class CarsPanel extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    collapsed: PropTypes.bool.isRequired,
    //
    intl: intlShape.isRequired,
  };

  generationsRenderer = option => (
    <div className={s.generations}>
      {option.photo && <img src={option.photo} className={s.genPhoto} alt="" />}
      <span className={s.genText}>
        {option.title} ({option.year_begin}&nbsp;-&nbsp;{option.year_end})
      </span>
    </div>
  );

  handleColorsChange = id => {
    this.props.selectedActions.set.colors(id);
  };

  handlePhotosToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.photos(!formState.photos ? 1 : null);
  };

  handleSwapToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.isSwap(!formState.isSwap ? 1 : null);
  };

  handleUnderLoanToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.isUnderLoan(!formState.isUnderLoan ? 1 : null);
  };

  handleFromAuctionToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.fromAuction(!formState.fromAuction ? 1 : null);
  };

  render() {
    const { formVocabulary, collapsed, formState, formData, selectedActions, intl } = this.props;

    const {
      makes,
      colors,
      categories,
      engines,
      drives,
      dealers,
      gearboxes,
      capacities,
      rent,
      credits,
      customs,
      states,
      options,
      europeanCountries,
      abroadOptions,
    } = formVocabulary;
    const { models, generations } = formData;
    const makesWithTopMakes = injectTopMakesToOptions(makes, intl);
    sortCollection(models, 'title');
    sortCollection(categories, 'title');

    const selectedSetActions = selectedActions.set;
    const pricePlaceholder = `${intl.formatMessage({ id: 'Цена от' })}, ${(formState.currency &&
      formState.currency.title) ||
      intl.formatMessage({ id: 'грн' })}`;

    const [
      formattedCredits,
      formattedStates,
      formattedRent,
      formattedDealers,
      formattedCustoms,
      formattedEuroCountries,
      formattedAbroadOptions,
    ] = [credits, states, rent, dealers, customs, europeanCountries, abroadOptions].map(
      propsArray =>
        propsArray.map(({ title, ...props }) => ({
          ...props,
          title: intl.formatMessage({ id: title }),
        })),
    );
    return (
      <div>
        <div className={s.mainform}>
          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Марка' })}
              instanceId="make-ff"
              name="make"
              options={makesWithTopMakes}
              labelKey="title"
              valueKey="id"
              disabled={!makes || !makes.length}
              onChange={selectedSetActions.make}
              value={formState.make}
              filterOption={skipTopMakes}
            />
          </div>
          <div className={s.filterItem}>
            <UpdatedSelect
              instanceId="model-ff"
              name="model"
              placeholder={intl.formatMessage({ id: 'Модель' })}
              labelKey="title"
              valueKey="id"
              disabled={!formState.make || !models || !models.length}
              options={models && models.map ? models : []}
              onChange={selectedSetActions.model}
              value={formState.model}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <Select
              instanceId="generation-ff"
              name="generation"
              placeholder={intl.formatMessage({ id: 'Поколение' })}
              labelKey="title"
              valueKey="id"
              optionRenderer={this.generationsRenderer}
              options={generations}
              disabled={!generations || !generations.length}
              onChange={selectedSetActions.generation}
              value={formState.generation}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <RegexpInput
              className={cx(s.input, s.from)}
              type="text"
              placeholder={pricePlaceholder}
              value={formState.priceFrom || ''}
              onChange={selectedSetActions.priceFrom}
              pattern={'^[0-9]+$'}
            />
            <RegexpInput
              className={cx(s.input, s.to)}
              type="text"
              placeholder={intl.formatMessage({ id: 'до' })}
              value={formState.priceTo || ''}
              onChange={selectedSetActions.priceTo}
              pattern={'^[0-9]+$'}
            />
          </div>
          <div className={s.filterItem}>
            <RegexpInput
              className={cx(s.input, s.from)}
              type="text"
              placeholder={intl.formatMessage({ id: 'Год, от' })}
              value={formState.yearFrom || ''}
              onChange={selectedSetActions.yearFrom}
              pattern={'^[0-9]+$'}
            />
            <RegexpInput
              className={cx(s.input, s.to)}
              type="text"
              placeholder={intl.formatMessage({ id: 'до' })}
              value={formState.yearTo || ''}
              onChange={selectedSetActions.yearTo}
              pattern={'^[0-9]+$'}
            />
          </div>
          <div className={s.filterItem}>
            <RegexpInput
              className={cx(s.input, s.from)}
              type="text"
              placeholder={intl.formatMessage({ id: 'Пробег от' })}
              value={formState.mileageFrom || ''}
              onChange={selectedSetActions.mileageFrom}
              pattern={'^[0-9]+$'}
            />
            <RegexpInput
              className={cx(s.input, s.to)}
              type="text"
              placeholder={intl.formatMessage({ id: 'до, тыс. км' })}
              value={formState.mileageTo || ''}
              onChange={selectedSetActions.mileageTo}
              pattern={'^[0-9]+$'}
            />
          </div>
          <div className={s.filterItem}>
            <SelectTranslated
              placeholder={intl.formatMessage({ id: 'Кузов' })}
              instanceId="categories-ff"
              name="categories"
              labelKey="title"
              valueKey="id"
              options={categories}
              onChange={selectedSetActions.category}
              value={formState.category}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <div className={s.flexContainer}>
              <div className={s.left}>
                <SelectTranslated
                  placeholder={intl.formatMessage({ id: 'Коробка' })}
                  instanceId="gearbox-ff"
                  name="gearboxes"
                  labelKey="title"
                  valueKey="id"
                  options={gearboxes}
                  onChange={selectedSetActions.gearbox}
                  value={formState.gearbox}
                  matchPos="start"
                />
              </div>
              <div className={s.right}>
                <SelectTranslated
                  placeholder={intl.formatMessage({ id: 'Привод' })}
                  instanceId="type-ff"
                  name="drives"
                  labelKey="title"
                  valueKey="id"
                  options={drives}
                  onChange={selectedSetActions.drive}
                  value={formState.drive}
                  matchPos="start"
                />
              </div>
            </div>
          </div>
          <div className={s.filterItem}>
            <SelectTranslated
              placeholder={intl.formatMessage({ id: 'двигатель' })}
              instanceId="engine-ff"
              name="engine"
              labelKey="title"
              valueKey="id"
              options={engines}
              onChange={selectedSetActions.engine}
              value={formState.engine}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Растаможка' })}
              instanceId="customs-ff"
              name="customs"
              labelKey="title"
              valueKey="id"
              searchable={false}
              disabled={!!formState.abroad && !!formState.abroad.value}
              options={formattedCustoms}
              onChange={selectedSetActions.isNotCleared}
              value={formState.isNotCleared}
            />
          </div>
          <div className={s.filterItem}>
            <Select
              placeholder={`${intl.formatMessage({ id: 'Пригнан из' })}...`}
              instanceId="drivenFrom-ff"
              name="drivenFrom"
              labelKey="title"
              valueKey="id"
              disabled={!!formState.abroad && !!formState.abroad.value}
              options={formattedEuroCountries}
              onChange={selectedSetActions.drivenFrom}
              value={formState.drivenFrom}
            />
          </div>
          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Авто не в Украине' })}
              instanceId="abroad-ff"
              name="abroad"
              labelKey="title"
              valueKey="id"
              searchable={false}
              options={formattedAbroadOptions}
              onChange={selectedSetActions.abroad}
              value={formState.abroad}
            />
          </div>
        </div>
        {!collapsed && (
          <div className={s.fullForm}>
            <div className={s.filterItem}>
              <ColorsForm
                colors={colors}
                selectedColors={formState.colors}
                selectColor={this.handleColorsChange}
              />
            </div>
            <div className={s.filterItem}>
              <RegexpInput
                className={cx(s.input, s.from)}
                type="text"
                placeholder={intl.formatMessage({ id: 'Мощность от, ' })}
                value={formState.powerFrom || ''}
                onChange={selectedSetActions.powerFrom}
                pattern={'^[0-9]+$'}
              />
              <RegexpInput
                className={cx(s.input, s.to)}
                type="text"
                placeholder={intl.formatMessage({ id: 'до, л.с.' })}
                value={formState.powerTo || ''}
                onChange={selectedSetActions.powerTo}
                pattern={'^[0-9]+$'}
              />
            </div>
            <div className={s.filterItem}>
              <div className={s.flexContainer}>
                <Select
                  className={s.selectFrom}
                  placeholder={intl.formatMessage({ id: 'Объем от, ' })}
                  instanceId="capacity-from-ff"
                  name="capacity-from"
                  labelKey="title"
                  valueKey="id"
                  options={capacities}
                  value={formState.capacityFrom}
                  onChange={selectedSetActions.capacityFrom}
                  searchable={false}
                />
                <Select
                  className={s.selectTo}
                  placeholder={intl.formatMessage({ id: 'до, л' })}
                  instanceId="capacity-to-ff"
                  name="capacity-to"
                  labelKey="title"
                  valueKey="id"
                  options={capacities}
                  value={formState.capacityTo}
                  onChange={selectedSetActions.capacityTo}
                  searchable={false}
                />
              </div>
            </div>
            <div className={s.filterItem}>
              {false && (
                <GroupForm
                  items={formattedDealers}
                  selected={formState.dealerType}
                  disabled
                  handleSelect={selectedSetActions.dealerType}
                />
              )}
              <Select
                placeholder={intl.formatMessage({ id: 'Аренда' })}
                instanceId="rent-ff"
                name="rent"
                labelKey="title"
                valueKey="id"
                searchable={false}
                options={formattedRent}
                onChange={selectedSetActions.isRent}
                value={formState.isRent}
              />
            </div>
            <div className={s.filterItem}>
              <Select
                placeholder={intl.formatMessage({ id: 'Кредит' })}
                instanceId="credit-ff"
                name="credit"
                labelKey="title"
                valueKey="id"
                searchable={false}
                options={formattedCredits}
                onChange={selectedSetActions.isSaleOnCredit}
                value={formState.isSaleOnCredit}
              />
            </div>
            <div className={s.filterItem}>
              <Select
                placeholder={intl.formatMessage({ id: 'Cостояние' })}
                instanceId="state-ff"
                name="state"
                labelKey="title"
                valueKey="id"
                searchable={false}
                disabled={formState.isNew}
                options={formattedStates}
                onChange={selectedSetActions.isCrashed}
                value={formState.isCrashed}
              />
            </div>
            <div className={s.filterItem}>
              <div className={s.flexContainer}>
                <div className={s.left}>
                  <label className={s.checkbox}>
                    <input
                      type="checkbox"
                      onChange={this.handleSwapToggle}
                      checked={!!formState.isSwap}
                    />{' '}
                    <FormattedMessage id="Обмен" />
                  </label>
                </div>
                <div className={s.right}>
                  <label className={s.checkbox}>
                    <input
                      type="checkbox"
                      onChange={this.handleUnderLoanToggle}
                      checked={!!formState.isUnderLoan}
                    />{' '}
                    <FormattedMessage id="Кредитный" />
                  </label>
                </div>
              </div>
            </div>
            <div className={s.filterItem}>
              <div className={s.flexContainer}>
                <div className={s.left}>
                  <label className={s.checkbox}>
                    <input
                      type="checkbox"
                      onChange={this.handlePhotosToggle}
                      checked={!!formState.photos}
                    />{' '}
                    <FormattedMessage id="Только с фото" />
                  </label>
                </div>
                <div className={s.right}>
                  <label className={s.checkbox}>
                    <input
                      type="checkbox"
                      onChange={this.handleFromAuctionToggle}
                      checked={!!formState.fromAuction}
                    />{' '}
                    <FormattedMessage id="С аукциона" />
                  </label>
                </div>
              </div>
            </div>
            <OptionsForm options={options} />
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(CarsPanel));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanel/CarsPanel/CarsPanel.js